import { createApi } from '@reduxjs/toolkit/query/react';

import { REFETCH_CURRENT_USER_SUCCESS } from '../../store/DEPRECATEDusers';
import { createBaseQuery } from './createBaseQuery';
export interface User {
  id: string;
  email: string;
  hasSubscription: boolean;
  first_name?: string;
  last_name?: string;
  userRole?: string;
  shouldCheckIsLegal?: boolean;
  birthday?: string;
  tokenBalance?: number;
  paymentProvider?: string;
  createdTimestamp?: number;
  updatedTimestamp?: number;
  subscription?: {
    price: number;
    currency: string;
    currentPeriodEndDate: number;
  };
  purchasedMediaPacks?: Array<{
    packId: string;
    title: string;
    price: number;
    purchasedAt: number;
  }>;
  
  [key: string]: unknown;
}
export interface UpdateUserByEmailRequest {
  email: string;
  data: Partial<User>;
}

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    getCurrentUser: builder.query<User, void>({
      query: () => ({
        url: '/me',
        method: 'GET',
        requiresAuth: true,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: user } = await queryFulfilled;

          dispatch({
            type: REFETCH_CURRENT_USER_SUCCESS,
            payload: user,
          });
        } catch (err) {
          throw err;
        }
      },
      providesTags: ['Users'],
    }),
    deleteCurrentUser: builder.mutation<void, void>({
      query: () => ({
        url: '/users/delete',
        method: 'POST',
        requiresAuth: true,
      }),
      invalidatesTags: ['Users'],
    }),
    findUserByEmail: builder.query<User, string>({
      query: (email) => ({
        url: `/admin/users/by-email/${email}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: (result) => 
        result ? [{ type: 'Users', id: result.id }] : ['Users'],
    }),
    updateUserByEmail: builder.mutation<User, UpdateUserByEmailRequest>({
      query: ({ email, data }) => ({
        url: `/admin/users/by-email/${email}`,
        method: 'PUT',
        body: data,
        requiresAuth: true,
      }),
      invalidatesTags: (result) => 
        result ? [{ type: 'Users', id: result.id }, 'Users'] : ['Users'],
    }),
  }),
});

export const { 
  useGetCurrentUserQuery, 
  useLazyGetCurrentUserQuery,
  useDeleteCurrentUserMutation,
  useFindUserByEmailQuery,
  useLazyFindUserByEmailQuery,
  useUpdateUserByEmailMutation,
} = usersApi;

